import React, { useState, useEffect } from 'react';
import LandingDesktop from './LandingDesktop';
import LandingMobile from './LandingMobile';

function Landing() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile ? <LandingMobile /> : <LandingDesktop />;
}

export default Landing;